export default {
  specialitiesListData(state) {
    return state.list.data
  },
  specialitiesSingleData(state) {
    return state.single.data
  },
  specialitiesSingleLoading(state) {
    return state.single.loading
  },
  getSpecialitiesById: (state) => (id) =>
    state.list.data.find((el) => el.id === id)
}
